import React from "react";
import Lottie from "react-lottie";
import * as animationData from "../../animations/bounching_ball.json";

export default ({ width, height }) => (
  <Lottie
    options={{
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid meet"
      }
    }}
    height={width || "100%"}
    width={height || "100%"}
  />
);



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js